var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{attrs:{"id":"app"}},[_c('nav',[(_vm.isLoggedIn)?_c('navigation-bar'):_vm._e()],1),_c('router-view',{staticClass:"universal-padding"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }